var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "just-validate"], function (require, exports, just_validate_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.strongPasswordValidator = exports.getValidatorWithTooltip = exports.Rules = void 0;
    just_validate_1 = __importDefault(just_validate_1);
    var Rules;
    (function (Rules) {
        Rules["Required"] = "required";
        Rules["Email"] = "email";
        Rules["MinLength"] = "minLength";
        Rules["MaxLength"] = "maxLength";
        Rules["Password"] = "password";
        Rules["Number"] = "number";
        Rules["MaxNumber"] = "maxNumber";
        Rules["MinNumber"] = "minNumber";
        Rules["StrongPassword"] = "strongPassword";
        Rules["CustomRegexp"] = "customRegexp";
    })(Rules = exports.Rules || (exports.Rules = {}));
    function getValidator(form) {
        return new just_validate_1.default(form, {
            errorFieldCssClass: 'is-invalid'
        });
    }
    exports.default = getValidator;
    function getValidatorWithTooltip(form) {
        return new just_validate_1.default(form, {
            errorFieldCssClass: 'is-invalid',
            tooltip: {
                position: 'bottom',
            },
        });
    }
    exports.getValidatorWithTooltip = getValidatorWithTooltip;
    function strongPasswordValidator(password) {
        if (typeof password == 'boolean')
            return true;
        var STRONG_PASSWORD_REGEXP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&#]{12,}$/;
        return STRONG_PASSWORD_REGEXP.test(password);
    }
    exports.strongPasswordValidator = strongPasswordValidator;
});
